/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LoginUser,
  RefreshJWT,
  UserCredentials,
} from '../models/index';
import {
    LoginUserFromJSON,
    LoginUserToJSON,
    RefreshJWTFromJSON,
    RefreshJWTToJSON,
    UserCredentialsFromJSON,
    UserCredentialsToJSON,
} from '../models/index';

export interface AuthLoginRequest {
    userCredentials: UserCredentials;
}

export interface AuthLoginWithAppleCodeRequest {
    code: string;
    clientType: string;
}

export interface AuthLoginWithGoogleCodeRequest {
    code: string;
    clientType: string;
}

export interface AuthRefreshJwtForExternalProviderRequest {
    refreshJWT: RefreshJWT;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     */
    async authLoginRaw(requestParameters: AuthLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginUser>> {
        if (requestParameters['userCredentials'] == null) {
            throw new runtime.RequiredError(
                'userCredentials',
                'Required parameter "userCredentials" was null or undefined when calling authLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCredentialsToJSON(requestParameters['userCredentials']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginUserFromJSON(jsonValue));
    }

    /**
     */
    async authLogin(requestParameters: AuthLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginUser> {
        const response = await this.authLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async authLoginWithAppleCodeRaw(requestParameters: AuthLoginWithAppleCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginUser>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling authLoginWithAppleCode().'
            );
        }

        if (requestParameters['clientType'] == null) {
            throw new runtime.RequiredError(
                'clientType',
                'Required parameter "clientType" was null or undefined when calling authLoginWithAppleCode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['clientType'] != null) {
            queryParameters['clientType'] = requestParameters['clientType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/redeem-apple-code`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginUserFromJSON(jsonValue));
    }

    /**
     */
    async authLoginWithAppleCode(requestParameters: AuthLoginWithAppleCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginUser> {
        const response = await this.authLoginWithAppleCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async authLoginWithGoogleCodeRaw(requestParameters: AuthLoginWithGoogleCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginUser>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling authLoginWithGoogleCode().'
            );
        }

        if (requestParameters['clientType'] == null) {
            throw new runtime.RequiredError(
                'clientType',
                'Required parameter "clientType" was null or undefined when calling authLoginWithGoogleCode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['clientType'] != null) {
            queryParameters['clientType'] = requestParameters['clientType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/redeem-google-code`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginUserFromJSON(jsonValue));
    }

    /**
     */
    async authLoginWithGoogleCode(requestParameters: AuthLoginWithGoogleCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginUser> {
        const response = await this.authLoginWithGoogleCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async authRefreshJwtForExternalProviderRaw(requestParameters: AuthRefreshJwtForExternalProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginUser>> {
        if (requestParameters['refreshJWT'] == null) {
            throw new runtime.RequiredError(
                'refreshJWT',
                'Required parameter "refreshJWT" was null or undefined when calling authRefreshJwtForExternalProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/refresh-jwt`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefreshJWTToJSON(requestParameters['refreshJWT']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginUserFromJSON(jsonValue));
    }

    /**
     */
    async authRefreshJwtForExternalProvider(requestParameters: AuthRefreshJwtForExternalProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginUser> {
        const response = await this.authRefreshJwtForExternalProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
